<template>
  <div class="payment" uk-height-viewport>
    <Header />
    <div class="uk-flex uk-flex-center">
      <div class="uk-position-center">
        <legend class="uk-legend uk-text-center">
          Vous souhaitez régler votre devis
          <b>{{quotationID}}</b>.
        </legend>
        <br />
        <br />
        <br />
        <br />
        <legend
          class="uk-legend uk-margin-bottom uk-text-center uk-text-bold"
        >Quel moyen de paiement souhaitez vous utiliser ?</legend>
        <div class="uk-margin-large-top" id="payment-options" v-show="!isLoading">
          <button
            class="uk-button uk-button-default uk-border-rounded uk-margin-medium-large uk-text-bold"
            v-on:click="createPaymentSession()"
          >Carte Bleue</button>
          <img
            style="cursor:pointer"
            v-on:click="createPaymentSession()"
            class="uk-margin-left"
            height="350"
            width="200"
            src="../assets/payment.png"
          />
        </div>

        <div
          class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
          uk-spinner
          v-show="isLoading"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";

let stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY);

export default {
  name: "payment",
  components: {
    Header
  },
  data() {
    return {
      isLoading: false,
      quotationID: ""
    };
  },

  mounted() {
    var self = this;
    self.quotationID = self.$route.params.quotationID;
  },

  methods: {

    createPaymentSession: function() {
      const self = this;
      var request = new XMLHttpRequest();

      var url =
        process.env.VUE_APP_ROOT_FIREBASE_PATH +
        ".cloudfunctions.net/createPaymentSession?quotationID=" +
        this.quotationID;

      request.open("POST", url, true);
      self.isLoading = true;
      request.onload = function() {
        if (request.status >= 200 && request.status < 400) {
          const data = JSON.parse(request.response);
          self.isLoading = false;
          self.redirectToCheckout(data.sessionID);
        }
      };
      var data = JSON.stringify({ quotationID: this.quotationID });
      request.send(data);
    },

    redirectToCheckout: function(sessionID) {
      stripe
        .redirectToCheckout({
          sessionId: sessionID
        })
        .then(function(result) {
          console.log(result)
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
        });
    }
  }
};
</script>


<style>
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
